import { debounce } from "./debounce";
import { EventEmitter } from "./event-emitter";

const breakpointConfig = { "xl": 1400, "lg": 1200, "md": 992, "sm": 768, "xs": 576 }

export class Breakpoints extends EventEmitter {

    constructor() {
        if (Breakpoints._instance) {
            return Breakpoints._instance;
        }
        super();
        Breakpoints._instance = this

        this.currentBreakpoint = this.getCurrentBreakpoint();
        window.addEventListener('resize', debounce(this._onWindowResize.bind(this), 250))
    }

    breakpointDown(breakpointName) {
        return (window.innerWidth < breakpointConfig[breakpointName])
    }

    breakpointUp(breakpointName) {
        return (window.innerWidth >= breakpointConfig[breakpointName])
    }

    getCurrentBreakpoint() {
        let bp = null
        for (const bpName in breakpointConfig) {
            const bpSize = breakpointConfig[bpName];
            if (bpSize > window.innerWidth) {
                bp = bpName;
            }
        }
        return bp;
    }

    getAll() {
        return breakpointConfig;
    }

    _onWindowResize() {
        const newBreakpoint = this.getCurrentBreakpoint();
        if (this.currentBreakpoint !== newBreakpoint) {
            const oldBreakpoint = this.currentBreakpoint;
            this.currentBreakpoint = newBreakpoint;
            this.emit('changed', {
                oldBreakpoint,
                currentBreakpoint: this.currentBreakpoint
            })
        }
    }

}